module.exports = __webpack_public_path__ + "images/emoji/post_office.4b3ef44d01f810009c66.png";